import { TAX_DETAILS } from '@/core/field-names';

export const TaxDetailFieldErrors = {
  InvalidNINumber: 'NI number is invalid',
  EmptyReason: 'Please select one',
  EmptyLoanOption: 'Please select one',
  EmptyLoanPlans: 'Please select one',
  EmptyP45: 'Please select one',
  EmptyP45Upload: 'P45 form is required.  If you dont have one, select No',
  EmptyDeclare: 'This is required',
};

export async function validateTaxDetails(field) {
  const isAlphaNumeric = /^[0-9a-zA-Z]+$/;
  const isPropertyExist = field.fileValue;
  switch (field.name) {
    case TAX_DETAILS.NATIONAL_INSURANCE_NUMBER:
      if (field.value) {
        if (!isAlphaNumeric.test(field.value) || field.value.length < 9) {
          return TaxDetailFieldErrors.InvalidNINumber;
        }
      }
      break;
    case TAX_DETAILS.REASON:
      if (!field.value) {
        return TaxDetailFieldErrors.EmptyReason;
      }
      break;
    case TAX_DETAILS.STUDENT_LOAN:
      if (!field.value) {
        return TaxDetailFieldErrors.EmptyLoanOption;
      }
      break;
    case TAX_DETAILS.LOAN_PLANS:
      if (field.appliedRules.visible && !field.value) {
        return TaxDetailFieldErrors.EmptyLoanPlans;
      }
      break;
    case TAX_DETAILS.P45:
      if (!field.value) {
        return TaxDetailFieldErrors.EmptyP45;
      }
      break;
    case TAX_DETAILS.P45_UPLOAD:
      if (field.appliedRules.visible && !isPropertyExist) {
        return TaxDetailFieldErrors.EmptyP45Upload;
      }
      break;
    case TAX_DETAILS.DECLARATION:
      if (!field.value) {
        return TaxDetailFieldErrors.EmptyDeclare;
      }
      break;
  }
  return '';
}
